import React from 'react';
import { hooks } from '@lifesize/clients.sdk';
import { connect, useSelector } from 'react-redux';
import IncomingCallModal from 'components/IncomingCallModal/IncomingCallModal';
import { closeFullScreenModal } from 'actions/FullScreenModal';
import { callActions, contactSelectors, remoteModeratorActions } from '@lifesize/nucleus';
import _get from 'lodash/get';

const mapStateToProps = (state, ownProps) => {
  const { incomingCall } = ownProps;
  const browser = _get(state, 'app.browser', {});
  const isLockedByModerator = ownProps.isLocked && !ownProps.isUserModerator;
  const dialString = _get(incomingCall, 'callerProperties.extension');
  let contact = null;
  if (dialString) {
    contact = contactSelectors.getContactByDialStringGenerator(state)(dialString);
  }

  const displayString =
    _get(contact, 'name') || _get(incomingCall, 'displayName') || _get(incomingCall, 'callerProperties.display_name');
  return {
    ...ownProps,
    isCallConnected: ownProps.isCallConnected,
    browser,
    displayString,
    isIncomingCallMeeting: contact && contact.isMeeting,
    call: ownProps.incomingCall,
    defaultAudioSetting: _get(state, 'app.settingsModal.defaultAudioSetting'),
    isLockedByModerator,
    isVisible: !!ownProps.incomingCall
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({
  answer: async (call, media) => {
    await dispatch(closeFullScreenModal());
    if (ownProps.remoteModerationIsActive) {
      await dispatch(remoteModeratorActions.leaveCurrent());
    }
    dispatch(callActions.answer(call, media));
  },
  add: (call) => {
    dispatch(callActions.add(call));
  },
  endAndAnswer: (call) => {
    dispatch(closeFullScreenModal());
    setTimeout(() => {
      dispatch(callActions.endAndAnswer(call));
    }, 0);
  },
  ignore: (call) => {
    dispatch(callActions.ignore(call));
  }
});

const ConnectedComponent = connect(mapStateToProps, mapDispatchToProps)(IncomingCallModal);

const FunctionalComponent = (props) => {
  const incomingCalls = hooks.useIncomingCalls();
  const isUserModerator = hooks.useIsCurrentUserModerator();
  const isLocked = hooks.useIsWaitingRoomEnabled();
  const remoteModerationIsActive = hooks.useIsRemoteModerationActive();
  const { localAudioMuted, localVideoMuted } = hooks.useMedia();
  const isCallConnected = hooks.useCallConnected();
  const localPrimaryStream = hooks.useLocalPrimaryStream()?.stream;
  const { localAudioMuted: defaultAudioMute, localVideoMuted: defaultVideoMute } = useSelector(
    (state) => state.app.mediaSettings
  );

  return (
    <ConnectedComponent
      {...props}
      incomingCall={incomingCalls[0]}
      isUserModerator={isUserModerator}
      isLocked={isLocked}
      remoteModerationIsActive={remoteModerationIsActive}
      isAudioMuted={localAudioMuted}
      isVideoMuted={localVideoMuted}
      isCallConnected={isCallConnected}
      localPrimaryStream={localPrimaryStream}
      defaultAudioMute={defaultAudioMute}
      defaultVideoMute={defaultVideoMute}
    />
  );
};

export { ConnectedComponent as IncomingCallModalContainer };
export default FunctionalComponent;
